<template>
  <div class="finance-statements">
    <MoreTitle title="现金流量表" @click="goPage">
      <template v-slot:left>
        {{ $t('现金流量表') }}<span class="laste-report-icon">{{ lasteReportDate }}</span>
      </template>
    </MoreTitle>
    <div class="edge-padding">
      <RowInfo label="经营净额">{{ $digitjs(financeData[formatAUs('netCashFromOperating')]).convert() }}</RowInfo>
      <RowInfo label="投资净额">{{ $digitjs(financeData[formatAUs('netCashFromInvesting')]).convert() }}</RowInfo>
      <RowInfo label="融资净额">{{ $digitjs(financeData[formatAUs('netCashFromFinancing')]).convert() }}</RowInfo>
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  props: ['reportTypeMap'],
  data() {
    return {
      financeData: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    lasteReportDate() {
      const { reportType, endDate, balanceSheetDate } = this.financeData
      const year = this.$dayjs(endDate).format('YYYY')
      const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
      const sortYear = isBefore ? +year + 1 : +year
      return endDate && reportType
        ? `(${this.$t('$x年', {
            x: sortYear
          })}${this.$t(this.reportTypeMap[reportType])})`
        : ''
    }
  },
  created() {
    this.getFinanceData()
  },
  methods: {
    // A股、美股字段特判
    formatAUs(val) {
      if (this.market === 'us') {
        return (
          {
            netCashFromOperating: 'netCFFO',
            netCashFromInvesting: 'netCFFI',
            netCashFromFinancing: 'netCFFF'
          }[val] ?? val
        )
      }

      if (this.market === 'hs') {
        return (
          {
            netCashFromOperating: 'netCashFlowOper',
            netCashFromInvesting: 'netCashFlowInv',
            netCashFromFinancing: 'netCashFlowFina'
          }[val] ?? val
        )
      }

      return val
    },
    async getFinanceData() {
      const search = this.getSearchInfo()
      const res = await this.$post(search.api, search.params)
      this.financeData = res.data?.[0] ?? {}
    },
    getSearchInfo() {
      const searchInfo = {
        hk: {
          api: this.$api.f10.hk + '/finance/cash',
          params: {
            symbol: this.symbol
          }
        },
        hs: {
          api: this.$api.f10.hs + '/finance/cash',
          params: {
            symbol: this.symbol
          }
        },
        us: {
          api: this.$api.f10.us + '/finance/cash-basic',
          params: {
            symbol: this.symbol,
            reportTypes: ['Q1', 'Q6', 'Q9', 'FY'],
            reportSize: 1
          }
        }
      }
      return searchInfo[this.market]
    },
    goPage() {
      this.$router.push({
        path: '/f10/statements',
        query: {
          symbol: this.symbol,
          type: 'cash'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
